import { List as IList } from 'immutable';

export const selectFeedContent = (state) => state.feedContentReducer.get('feedContent', IList());
export const selectLoaderVisible = (state) => state.feedContentReducer.get('loaderVisible', false);
export const selectSuggestedTags = (state) => state.feedContentReducer.get('tags', IList());
export const selectProductDemandType = (state) => state.productsDemandsReducer.get('productDemandType', 'product');
export const selectUserFeedContent = (state) => state.feedContentReducer.get('userFeedContent', IList());
